var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GChart',{ref:"gChart",staticClass:"chart",attrs:{"type":_vm.chartType,"data":_vm.chartData,"options":_vm.chartOptions,"settings":{packages: ['corechart', 'table', 'geochart']}},on:{"ready":_vm.onChartReady}})}
var staticRenderFns = []

export { render, staticRenderFns }